export const GET_ALL_WORKOUT = 'GET_ALL_WORKOUT';
export const GET_ALL_WORKOUT_SUCCESS = 'GET_ALL_WORKOUT_SUCCESS';

export const GET_MORE_WORKOUT = 'GET_MORE_WORKOUT';
export const GET_MORE_WORKOUT_SUCCESS = 'GET_MORE_WORKOUT_SUCCESS';
export const GET_MORE_WORKOUT_EMPTY = 'GET_MORE_WORKOUT_EMPTY';

export const GET_WORKOUT_FAIL = 'GET_WORKOUT_FAIL';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/SearchWorkoutActionTypes.js